import resourceFactory from 'common/admin/resourceFactory'

const actions = resourceFactory('businesses')

export default actions
